import apiRequest from './apiRequest';

/**
 * Request body for PATCH /characters/:characterID.
 * All fields optional. Response includes presigned GET URLs for config.json and temp-config.json plus upload URLs.
 * @see https://api-docs.getcartwheel.com/api/call-update-character
 */
export type PatchUpdateCharacterRequest = {
  characterName?: string;
  characterDescription?: string;
  requestConfigUploadURL?: boolean;
  requestTempConfigUploadURL?: boolean;
};

export type PatchUpdateCharacterResponse = {
  characterID: string;
  uploadStatus: string;
  characterName: string;
  characterDescription: string;
  fileExtension: string;
  createdAt: string;
  createdBy: string;
  thumbnailURL: string;
  /** Presigned GET for config.json; use configUploadURL to replace it. */
  configURL: string;
  /** Presigned GET for temp-config.json; use tempConfigUploadURL to create or replace it. */
  tempConfigURL: string;
  configUploadURL: string;
  tempConfigUploadURL: string;
  thumbnailUploadURL?: string | null;
};

/**
 * Update character fields (PATCH /characters/:characterID).
 * Returns updated character with presigned read URLs (saved and temp config) and upload URLs for Cartographer.
 */
export default async function patchUpdateCharacter(
  apiKey: string,
  characterID: string,
  body: PatchUpdateCharacterRequest = {},
) {
  return apiRequest<PatchUpdateCharacterResponse>(
    'external-mogen',
    `/characters/${encodeURIComponent(characterID)}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(body),
    },
  );
}
